import { useEffect, useState } from 'react';
// @mui
import { Typography, Card, Stack } from '@mui/material';
// components
import Avatar from '../../components/Avatar';
// constants
import { POSITION_OPTION_DICT } from '../../constants';

const positionDict = POSITION_OPTION_DICT;

export default function PositionLabel({ position, detailRole, aiSelected=false }) {
  const bgColors = {
    'developer': 'rgba(51, 102, 255, 0.08)',
    'designer': 'rgba(255, 193, 7, 0.08)',
    'product-manager': 'rgba(255, 72, 66, 0.08)',
    'marketer': 'rgba(0, 171, 85, 0.08)',
    'operator': 'rgba(255, 189, 152, 0.24)',
    'finance': 'rgba(145, 158, 171, 0.08)',
    'engineer': 'rgba(24, 144, 255, 0.08)',
    'ai-data': 'rgba(255, 64, 129, 0.08)',
  };
  if (!position) return <></>;

  const [label, setLabel] = useState('');

  useEffect(() => {
    if (detailRole?.role === "하드웨어 엔지니어") {
      setLabel("engineer");
    } else if (aiSelected) {
      setLabel("ai-data");
    } else {
      setLabel(position);
    }
  }, [position, detailRole]);

  return (
    <Card
      sx={{
        boxShadow: 'none',
        padding: (theme) => theme.spacing(0.75, 1.5, 0.75, 1.5),
        borderRadius: 1.5,
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        bgcolor: bgColors[label],
        whiteSpace: 'nowrap'
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
      <Avatar
        sx={{ width: 28, height: 28 }}
        src={`https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/position/position_${label}.png`}
      />
      <Typography variant="h6">
        {positionDict[label]}
      </Typography>
      </Stack>
    </Card>
  )
}